import React from 'react';
import styles from './styles.module.scss';

const Dash = () => (
  <div className={styles.dash}/>
);

export default Dash;
